"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PedestrianSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M10.37 22.55a3.77 3.77 0 01-.84 1.25l-2.95 2.92a1.9 1.9 0 000 2.71 2 2 0 002.75 0l3.59-3.54a5.33 5.33 0 00.84-1.26l.85-2a36.31 36.31 0 01-2.85-3.13c-.12.02-1.39 3.05-1.39 3.05z"/><path d="M24.25 14.34L24 14.2l-1.37-.73-.53-1.67a6.37 6.37 0 00-3.45-3.87A3 3 0 0021 5a3 3 0 00-6 0 3 3 0 001.13 2.33H16c-2.11 0-3.38.62-5.6 1.46a5.7 5.7 0 00-2.95 2.71l-.32.84c-.25 1.11-.1 2 .83 2.5a1.89 1.89 0 002.51-.84l.42-.83a2.06 2.06 0 01.95-.94l1.59-.62-.95 3.54a3.67 3.67 0 00.84 3.44l3.59 3.86a3.14 3.14 0 01.84 1.67l1.06 4.28a1.9 1.9 0 002.32 1.35 1.87 1.87 0 001.37-2.29l-1.37-5.22a4.91 4.91 0 00-.84-1.66l-2.75-2.93 1.06-4.06.31.94a3.65 3.65 0 001.9 2.19l1.38.73a1.91 1.91 0 002.53-.84 1.62 1.62 0 00-.47-2.27z"/>';
var PedestrianSVG = function PedestrianSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.PedestrianSVG = PedestrianSVG;
PedestrianSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(PedestrianSVG);
exports.default = _default;